const cdnURL = "https://d3etfstcuyoos5.cloudfront.net/";
const baseURL = "https://d3etfstcuyoos5.cloudfront.net/app-images/"
const baseImgURL = "https://d3etfstcuyoos5.cloudfront.net/app-images/imgs/"
const flaticonSvg = 'https://d3etfstcuyoos5.cloudfront.net/app-images/sharpely-assets/svg/'

export { cdnURL, baseURL, baseImgURL, flaticonSvg };